export default {
  index: {
    tsevents:"最新活動",
    education:"教育",
    charity:"公益慈善",
    viewdetails:"查看詳情",
    homepage:"主頁",
    breadcrumbtitle:'音樂總監',
    aboutus:"關於我們",
    contactus:'聯絡我們',
    copyright:'大灣區管弦樂團 版權所有',
    back:'返回',
    adminlogin:'管理登錄',
    title:'大灣區管弦樂團',
    privacypolicy:'免責條款',
    disclaimerclause:'私隱政策',
    termsconditionsuse:'使用條款細則',
  },
}

